module.exports = __webpack_public_path__ + "img/logo_piperun_preta.62413162.png";